import { gsap,ScrollTrigger,ScrollToPlugin,Back,Elastic,Circ,Expo,Sine,Linear} from 'gsap/all';
/*================================

Language

================================*/
export class Language {
    constructor(pamph) {
        this.pamph = pamph;
        this.lang = document.querySelector('.js-language');
        this.langBtn = document.querySelector('.js-language-button');
        this.langLists = document.querySelector('.js-language-lists');

        this.init();
    }

    //初期設定
    init() {
        this.lang.addEventListener('mouseover',(e) => {
            if(this.lang.contains(e.relatedTarget)) return;
            this.open();
        })
        this.lang.addEventListener('mouseout',(e) => {
            if(this.lang.contains(e.relatedTarget)) return;
            this.close();
        });

        this.langBtn.addEventListener('touchstart',(e) => {
            if(this.lang.classList.contains('is-open')) {
                this.close();
            } else {
                this.open();
            }

        });


    }

    open() {
        this.lang.classList.add('is-open');
        gsap.to(this.langLists,{
            height: 'auto',
            duration: .3
        })

    }

    close() {
        this.lang.classList.remove('is-open');
        gsap.to(this.langLists,{
            height: 0,
            duration: .3
        })

    }

}